import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import GKShortsTable from './GKShortsTable';
const GKShorts = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Gk Shorts' parent='Gk Shorts'  />
      <Container fluid={true}>
        <Row>
          <GKShortsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default GKShorts;
